import React, { useEffect, useMemo, useState } from 'react'
import { FORM_URL } from './Consts'

const photos = ['/image1.jpg', '/image2.jpg', '/image3.jpg']

const styles = `
html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
}

.app {
  --pink: #ff4f7b;
  --pink-2: #ff8aa5;
  --gold: #ffc857;
  --navy: #111827;
  --ink: #263040;
  --muted: #667085;
  --line: #ffe0e8;
  --soft: #fff5f8;
  min-height: 100vh;
  background: #fff9fb;
  color: var(--ink);
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
  line-height: 1.5;
  overflow-x: hidden;
}

.app * {
  box-sizing: border-box;
}

button,
input,
a {
  font: inherit;
}

.hero {
  position: relative;
  isolation: isolate;
  color: #fff;
  padding: 28px clamp(20px, 4vw, 52px) 76px;
  background:
    radial-gradient(circle at 14% 12%, rgba(255, 79, 123, .38), transparent 30%),
    radial-gradient(circle at 86% 10%, rgba(255, 200, 87, .24), transparent 28%),
    radial-gradient(circle at 72% 78%, rgba(255, 138, 165, .18), transparent 34%),
    linear-gradient(135deg, #111827 0%, #241726 52%, #111827 100%);
  overflow: hidden;
}

.hero::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -2;
  background: linear-gradient(180deg, rgba(255,255,255,.08), transparent 34%, rgba(255,255,255,.04));
}

.hero::after {
  content: "";
  position: absolute;
  width: 760px;
  height: 760px;
  right: -280px;
  bottom: -320px;
  z-index: -1;
  border-radius: 999px;
  background: rgba(255, 79, 123, .10);
  filter: blur(10px);
}

.nav {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.brand {
  font-size: 20px;
  font-weight: 950;
  letter-spacing: -.5px;
  white-space: nowrap;
}

.nav-badge {
  padding: 10px 16px;
  border-radius: 999px;
  background: rgba(255,255,255,.10);
  border: 1px solid rgba(255,255,255,.18);
  color: rgba(255,255,255,.88);
  font-size: 13px;
  font-weight: 850;
  backdrop-filter: blur(14px);
  white-space: nowrap;
}

.hero-layout {
  width: 100%;
  max-width: 1240px;
  margin: clamp(46px, 7vh, 82px) auto 0;
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(420px, .92fr);
  gap: clamp(34px, 5vw, 76px);
  align-items: start;
  opacity: 0;
  transform: translateY(18px);
  transition: opacity .75s ease, transform .75s ease;
}

.app.is-loaded .hero-layout {
  opacity: 1;
  transform: translateY(0);
}

.hero-copy {
  min-width: 0;
  max-width: 700px;
}

.eyebrow {
  width: fit-content;
  max-width: 100%;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 11px 16px;
  border-radius: 999px;
  background: rgba(255,255,255,.11);
  border: 1px solid rgba(255,255,255,.18);
  color: #ffe9ef;
  font-weight: 900;
  font-size: 14px;
  backdrop-filter: blur(16px);
}

.eyebrow-dot {
  width: 11px;
  height: 11px;
  border-radius: 999px;
  background: var(--gold);
  box-shadow: 0 0 0 6px rgba(255,200,87,.12);
  flex: 0 0 auto;
}

.hero-title {
  margin: 22px 0 0;
  max-width: 680px;
  font-size: clamp(48px, 5.4vw, 76px);
  line-height: .96;
  letter-spacing: -.06em;
  font-weight: 950;
}

.hero-lead {
  margin: 22px 0 0;
  max-width: 660px;
  color: rgba(255,255,255,.80);
  font-size: clamp(17px, 1.35vw, 20px);
}


.proof-badge {
    width: fit-content;
    max-width: 100%;
    margin: 18px 0 0;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 11px 15px;
    border-radius: 999px;
    background: linear-gradient(135deg, rgba(255,255,255,.14), rgba(255,255,255,.07));
    border: 1px solid rgba(255,255,255,.18);
    color: rgba(255,255,255,.90);
    font-size: 14px;
    font-weight: 850;
    box-shadow: 0 18px 46px rgba(0,0,0,.16);
    backdrop-filter: blur(16px);
  }
  
  .proof-badge::before {
    content: "";
    width: 10px;
    height: 10px;
    border-radius: 999px;
    background: var(--gold);
    box-shadow: 0 0 0 6px rgba(255,200,87,.13);
    flex: 0 0 auto;
  }

.requirements-strip {
  margin-top: 26px;
  max-width: 680px;
  border-radius: 28px;
  padding: 20px;
  background: rgba(255,255,255,.105);
  border: 1px solid rgba(255,255,255,.16);
  backdrop-filter: blur(18px);
  box-shadow: 0 24px 60px rgba(0,0,0,.16);
}

.strip-title {
  margin-bottom: 14px;
  color: var(--gold);
  font-size: 12px;
  font-weight: 950;
  letter-spacing: 1.6px;
  text-transform: uppercase;
}

.chip-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.req-chip {
  display: inline-flex;
  align-items: center;
  min-height: 38px;
  padding: 0 14px;
  border-radius: 999px;
  background: rgba(255,255,255,.12);
  border: 1px solid rgba(255,255,255,.16);
  color: rgba(255,255,255,.90);
  font-size: 13.5px;
  font-weight: 850;
  line-height: 1;
  white-space: nowrap;
}

.reward-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-top: 24px;
  max-width: 680px;
}

.reward-card {
  min-width: 0;
  border-radius: 26px;
  padding: 22px;
  background: rgba(255,255,255,.115);
  border: 1px solid rgba(255,255,255,.16);
  box-shadow: 0 24px 70px rgba(0,0,0,.20);
  backdrop-filter: blur(18px);
}

.reward-amount {
  color: var(--gold);
  font-size: clamp(34px, 3.2vw, 42px);
  font-weight: 950;
  letter-spacing: -1.6px;
  line-height: 1;
  margin-bottom: 8px;
  white-space: nowrap;
}

.reward-copy {
  color: rgba(255,255,255,.84);
  font-weight: 750;
  font-size: 15px;
}

.lead-form {
  margin-top: 24px;
  max-width: 680px;
  border-radius: 28px;
  padding: 16px;
  background: rgba(255,255,255,.12);
  border: 1px solid rgba(255,255,255,.16);
  backdrop-filter: blur(18px);
  box-shadow: 0 28px 90px rgba(0,0,0,.22);
}

.form-grid {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 12px;
}

.phone-input.country-code {
  width: 90px;
  flex-shrink: 0;
}
  
.phone-input {
  width: 100%;
  min-width: 0;
  border: 1px solid rgba(255,255,255,.18);
  outline: none;
  border-radius: 18px;
  padding: 17px 18px;
  font-size: 18px;
  color: var(--navy);
  background: rgba(255,255,255,.96);
  box-shadow: 0 12px 34px rgba(0,0,0,.12);
}

.phone-input:focus {
  border-color: rgba(255,79,123,.72);
  box-shadow: 0 0 0 4px rgba(255,79,123,.14), 0 12px 34px rgba(0,0,0,.12);
}

.form-button {
  border: 0;
  border-radius: 18px;
  padding: 0 24px;
  min-width: 190px;
  min-height: 58px;
  white-space: nowrap;
  font-size: 17px;
  font-weight: 950;
  color: #fff;
  background: linear-gradient(135deg, var(--pink), var(--pink-2));
  cursor: pointer;
  box-shadow: 0 16px 34px rgba(255,79,123,.38);
  transition: transform .18s ease, box-shadow .18s ease, filter .18s ease;
}

.form-button:not(:disabled):hover {
  transform: translateY(-1px);
  filter: brightness(1.03);
  box-shadow: 0 20px 42px rgba(255,79,123,.44);
}

.form-button:disabled {
  color: #777;
  background: #d7d7d7;
  cursor: not-allowed;
  box-shadow: none;
}

.micro {
  margin: 12px 2px 0;
  color: rgba(255,255,255,.68);
  font-size: 12.5px;
}

.success {
  text-align: center;
  padding: 12px 8px;
}

.success-title {
  font-size: 28px;
  font-weight: 950;
  margin-bottom: 6px;
}

.success-copy {
  color: rgba(255,255,255,.76);
}

.profile-card {
  min-width: 0;
  width: 100%;
  border-radius: 34px;
  padding: 16px;
  background: rgba(255,255,255,.96);
  box-shadow: 0 34px 100px rgba(0,0,0,.32);
  border: 1px solid rgba(255,255,255,.72);
  color: var(--navy);
  display: grid;
  gap: 16px;
}

.photo-card {
  position: relative;
  height: clamp(380px, 42vw, 510px);
  border-radius: 26px;
  overflow: hidden;
  background: linear-gradient(135deg, #f4f4f5, #e5e7eb);
  box-shadow: inset 0 0 0 1px rgba(255,255,255,.24);
}

.photo-fallback {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  color: rgba(17,24,39,.24);
  font-size: 54px;
  font-weight: 950;
  letter-spacing: -.05em;
}

.photo-card img {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.photo-card::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 2;
  background: linear-gradient(180deg, rgba(0,0,0,.02), rgba(0,0,0,.10) 64%, rgba(0,0,0,.42));
  pointer-events: none;
}

.photo-arrow {
  position: absolute;
  top: 50%;
  z-index: 4;
  transform: translateY(-50%);
  width: 42px;
  height: 42px;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,.34);
  background: rgba(0,0,0,.36);
  color: #fff;
  cursor: pointer;
  backdrop-filter: blur(12px);
  display: grid;
  place-items: center;
  font-size: 24px;
  line-height: 1;
}

.photo-arrow.left {
  left: 14px;
}

.photo-arrow.right {
  right: 14px;
}

.photo-dots {
  position: absolute;
  z-index: 4;
  bottom: 14px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 8px;
}

.photo-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  border: 0;
  padding: 0;
  background: rgba(255,255,255,.48);
  cursor: pointer;
  transition: width .22s ease, background .22s ease;
}

.photo-dot.active {
  width: 24px;
  background: #fff;
}

.profile-content {
  border-radius: 26px;
  padding: 24px;
  background: linear-gradient(180deg, #ffffff, #fff6f8);
  border: 1px solid var(--line);
}

.profile-top {
  display: grid;
  gap: 12px;
}

.profile-name {
  margin: 0;
  font-size: 38px;
  line-height: 1;
  letter-spacing: -1.3px;
}

.profile-badge {
  width: fit-content;
  max-width: 100%;
  padding: 8px 12px;
  border-radius: 999px;
  background: var(--soft);
  color: var(--pink);
  border: 1px solid var(--line);
  font-size: 12.5px;
  font-weight: 900;
  line-height: 1.2;
}

.profile-copy {
  margin: 2px 0 0;
  color: var(--muted);
  font-size: 15.5px;
}

.stat-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin-top: 18px;
}

.stat {
  min-width: 0;
  padding: 14px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid var(--line);
}

.stat-label {
  color: #98a2b3;
  font-size: 11px;
  letter-spacing: .7px;
  text-transform: uppercase;
  font-weight: 900;
  margin-bottom: 4px;
  white-space: nowrap;
}

.stat-value {
  color: var(--navy);
  font-size: 16px;
  font-weight: 950;
  line-height: 1.12;
}

.traits {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.trait {
  padding: 8px 10px;
  border-radius: 999px;
  background: var(--soft);
  color: var(--pink);
  border: 1px solid var(--line);
  font-size: 12.5px;
  font-weight: 850;
  white-space: nowrap;
}

.profile-note {
  margin-top: 16px;
  color: var(--muted);
  font-size: 14px;
}

.section {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 84px clamp(18px, 4vw, 52px);
}

.section.tight {
  padding-top: 22px;
}

.section-head {
  max-width: 760px;
  margin: 0 auto 32px;
  text-align: center;
}

.section-title {
  margin: 0;
  color: var(--navy);
  font-size: clamp(34px, 4vw, 46px);
  line-height: 1.04;
  letter-spacing: -.05em;
  font-weight: 950;
}

.section-sub {
  margin: 13px auto 0;
  color: var(--muted);
  font-size: clamp(16px, 1.4vw, 18px);
}

.criteria-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.criteria-card,
.info-card {
  background: #fff;
  border: 1px solid var(--line);
  box-shadow: 0 22px 70px rgba(17,24,39,.07);
}

.criteria-card {
  min-width: 0;
  min-height: 176px;
  padding: 24px;
  border-radius: 28px;
}

.criteria-icon {
  width: fit-content;
  min-width: 58px;
  height: 48px;
  padding: 0 12px;
  border-radius: 18px;
  background: linear-gradient(135deg, var(--soft), #fff);
  color: var(--pink);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 950;
  border: 1px solid var(--line);
  margin-bottom: 15px;
  white-space: nowrap;
  line-height: 1;
}

.criteria-title {
  margin: 0 0 7px;
  color: var(--navy);
  font-size: 19px;
  letter-spacing: -.3px;
}

.criteria-copy {
  margin: 0;
  color: var(--muted);
  font-size: 15px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.info-card {
  padding: clamp(24px, 3vw, 32px);
  border-radius: 30px;
}

.info-title {
  margin: 0;
  color: var(--navy);
  font-size: clamp(30px, 3vw, 36px);
  line-height: 1.04;
  letter-spacing: -.045em;
  font-weight: 950;
}

.info-list {
  list-style: none;
  padding: 0;
  margin: 20px 0 0;
  display: grid;
  gap: 14px;
}

.info-item {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  color: #4b5563;
  font-size: 16px;
}

.check {
  width: 24px;
  height: 24px;
  border-radius: 999px;
  flex: 0 0 24px;
  background: linear-gradient(135deg, var(--pink), var(--pink-2));
  color: #fff;
  display: grid;
  place-items: center;
  font-size: 13px;
  font-weight: 950;
  margin-top: 1px;
}

.cta {
  position: relative;
  overflow: hidden;
  max-width: 960px;
  margin: 0 auto;
  border-radius: 34px;
  padding: clamp(30px, 4vw, 46px);
  text-align: center;
  background: linear-gradient(135deg, var(--navy), #2a1723);
  color: #fff;
  box-shadow: 0 30px 90px rgba(17,24,39,.18);
}

.cta::before {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 20% 20%, rgba(255,79,123,.30), transparent 34%),
    radial-gradient(circle at 80% 18%, rgba(255,200,87,.22), transparent 30%);
}

.cta-inner {
  position: relative;
  max-width: 660px;
  margin: 0 auto;
}

.cta .section-title {
  color: #fff;
}

.cta .section-sub {
  color: rgba(255,255,255,.76);
}

.cta-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 52px;
  margin-top: 24px;
  padding: 0 22px;
  border-radius: 999px;
  color: #fff;
  text-decoration: none;
  font-weight: 950;
  background: linear-gradient(135deg, var(--pink), var(--pink-2));
  box-shadow: 0 16px 34px rgba(255,79,123,.32);
}

.footer {
  padding: 36px 18px;
  text-align: center;
  background: #fff1f5;
  color: #7a8290;
  font-size: 14px;
}

@media (max-width: 1050px) {
  .hero {
    padding-bottom: 64px;
  }

  .hero-layout {
    grid-template-columns: 1fr;
    max-width: 760px;
  }

  .hero-copy {
    max-width: none;
  }

  .hero-title,
  .hero-lead,
  .requirements-strip,
  .reward-row,
  .lead-form {
    max-width: none;
  }

  .profile-card {
    max-width: 720px;
  }

  .photo-card {
    height: clamp(380px, 64vw, 540px);
  }

  .criteria-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .info-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .hero {
    padding: 22px 16px 52px;
  }

  .nav-badge {
    display: none;
  }

  .brand {
    font-size: 18px;
  }

  .hero-layout {
    margin-top: 42px;
    gap: 28px;
  }

  .eyebrow {
    font-size: 13px;
    padding: 10px 14px;
  }

  .hero-title {
    font-size: clamp(40px, 12vw, 54px);
    letter-spacing: -.055em;
  }

  .requirements-strip,
  .lead-form,
  .reward-card,
  .profile-content {
    padding: 18px;
  }

  .req-chip {
    white-space: normal;
  }

  .reward-row,
  .criteria-grid {
    grid-template-columns: 1fr;
  }

  .form-grid {
        grid-template-columns: 90px minmax(0, 1fr);
      }
    
      .form-button {
        grid-column: 1 / -1;
    }

  .form-button {
    width: 100%;
    padding: 0 18px;
  }

  .profile-card {
    padding: 10px;
    border-radius: 28px;
  }

  .photo-card {
    height: 360px;
    border-radius: 22px;
  }

  .profile-content {
    border-radius: 22px;
  }

  .profile-name {
    font-size: 34px;
  }

  .stat-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .section {
    padding: 58px 18px;
  }

  .section.tight {
    padding-top: 10px;
  }

  .criteria-card {
    min-height: auto;
  }
}
`

function App() {
  const [countryCode, setCountryCode] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [loaded, setLoaded] = useState(false)
  const [busy, setBusy] = useState(false)
  const [done, setDone] = useState(false)
  const [photoIndex, setPhotoIndex] = useState(0)

  const [carouselHovered, setCarouselHovered] = useState(false)
  const [autoScrollOff, setAutoScrollOff] = useState(false)

  useEffect(() => {
    setLoaded(true)
  }, [])

  useEffect(() => {
    const t = setInterval(() => {
      if (carouselHovered || autoScrollOff) return

      setPhotoIndex(i => (i + 1) % photos.length)
    }, 4200)

    return () => clearInterval(t)
  }, [carouselHovered, autoScrollOff])

  const ready = useMemo(() => countryCode.trim().length > 0 && phoneNumber.trim().length >= 6, [countryCode, phoneNumber])

  const submit = async e => {
    e.preventDefault()
    if (!ready || busy) return

    setBusy(true)

    try {
      const payload = {
        phone: `${countryCode.trim()} ${phoneNumber.trim()}`,
        source: 'Find Jim a Wife',
        reward: {
          dating: '$3,000 USD after 3 months of successful dating',
          marriage: '$10,000 USD upon marriage',
        },
        contract: 'Jim signs a legally binding contract with the referrer upon a successful first date.',
        criteria: {
          age: '21 to 28',
          height: '167cm+',
          build: 'thin',
          ethnicity: 'Caucasian',
        },
        jim: {
          occupation: 'Senior Software Engineer',
          location: 'Europe',
          relocation: 'Open to move',
        },
        submittedAt: new Date().toISOString(),
      }

      const res = await fetch(FORM_URL, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      })

      if (!res.ok) {
        const t = await res.text()
        throw new Error(`${res.status} ${t}`)
      }

      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'Lead')
        window.fbq('track', 'CompleteRegistration')
      }

      setDone(true)
    } catch (err) {
      console.error(err)
      alert('Sorry, something went wrong. Please try again.')
    } finally {
      setBusy(false)
    }
  }

  const prevPhoto = () => setPhotoIndex(i => (i - 1 + photos.length) % photos.length)
  const nextPhoto = () => {
    setAutoScrollOff(true)
    setPhotoIndex(i => (i + 1) % photos.length)
  }

  const scrollToLeadForm = e => {
    e.preventDefault()


    const el = document.getElementById('lead-form')
    if (!el) return

    window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`)

    el.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    })

  }


  return (
    <div className={`app ${loaded ? 'is-loaded' : ''}`}>
      <style>{styles}</style>

      <section className="hero">
        <nav className="nav">
          <div className="brand">Find Jim a Wife</div>
        </nav>

        <div className="hero-layout">
          <div className="hero-copy">

            <h1 className="hero-title">Know someone perfect for Jim?</h1>

            <p className="hero-lead">
              Hi, I'm Jim and I am going <b>all in</b> to find the right person. If you know someone who fits what I am looking for, leave your number and I will reach out privately.
            </p>

                  <p className="proof-badge">Am I real? I can do a video call to confirm</p>


            <div className="requirements-strip">
              <div className="strip-title">Key Requirements</div>
              <div className="chip-group">
                <span className="req-chip">Age 20-26</span>
                <span className="req-chip">Height 167cm+</span>
                <span className="req-chip">Thin build</span>
                <span className="req-chip">Caucasian</span>
              </div>
            </div>

            <div className="reward-row">
              <div className="reward-card">
                <div className="reward-amount">$3,000</div>
                <div className="reward-copy">Paid after 3 months of successful dating</div>
              </div>
              <div className="reward-card">
                <div className="reward-amount">$10,000</div>
                <div className="reward-copy">Paid upon marriage</div>
              </div>
            </div>

            <div className="lead-form" id="lead-form">
              {!done ? (
                <form onSubmit={submit}>
                  <div className="form-grid">
                    <input
                      className="phone-input country-code"
                      type="tel"

                      name="countryCode"
                      placeholder="+1"
                      value={countryCode}
                      onChange={e => setCountryCode(e.target.value)}
                    />
                    <input
                      className="phone-input"
                      type="tel"
                      name="phone"
                      placeholder="Phone number"
                      value={phoneNumber}
                      onChange={e => setPhoneNumber(e.target.value)}
                      required
                      inputMode="tel"
                      autoComplete="tel"
                    />
                    <button className="form-button" type="submit" disabled={!ready || busy}>
                      {busy ? 'Sending…' : 'I Know Someone'}
                    </button>
                  </div>
                  <div className="micro">
                    I will contact you directly. No spam, no public posting, and every introduction will be respectful.
                  </div>
                </form>
              ) : (
                <div className="success">
                  <div className="success-title">Thank you</div>
                  <div className="success-copy">Your number has been received. I will reach out soon, thank you!</div>
                </div>
              )}
            </div>
          </div>

          <aside className="profile-card">
            <div
              className="photo-card"
              onMouseEnter={() => setCarouselHovered(true)}
              onMouseLeave={() => setCarouselHovered(false)}
            >
              <div className="photo-fallback">Jim</div>
              <img
                style={{
                  backgroundColor: "transparent",
                }}
                src={photos[photoIndex]}
                alt="Jim"
                onError={e => {
                  e.currentTarget.style.opacity = 0
                }}
              />

              <button type="button" aria-label="Previous photo" onClick={prevPhoto} className="photo-arrow left">
                ‹
              </button>
              <button type="button" aria-label="Next photo" onClick={nextPhoto} className="photo-arrow right">
                ›
              </button>

              <div className="photo-dots">
                {photos.map((_, i) => (
                  <button
                    key={i}
                    type="button"
                    aria-label={`Photo ${i + 1}`}
                    aria-current={i === photoIndex ? 'true' : undefined}
                    onClick={() => setPhotoIndex(i)}
                    className={`photo-dot ${i === photoIndex ? 'active' : ''}`}
                  />
                ))}
              </div>
            </div>

            <div className="profile-content">
              <div className="profile-top">
                <h2 className="profile-name">Jim</h2>
                <div className="profile-badge">Senior Software Engineer</div>
                <p className="profile-copy">
                  A genuinely nice, easy-going guy who is serious about finding the right person. Lives in Europe and is open to moving.
                </p>
              </div>

              <div className="stat-grid">
                <div className="stat">
                  <div className="stat-label">Age</div>
                  <div className="stat-value">30</div>
                </div>
                <div className="stat">
                  <div className="stat-label">Height</div>
                  <div className="stat-value">175cm</div>
                </div>
                <div className="stat">
                  <div className="stat-label">Lives</div>
                  <div className="stat-value">Europe</div>
                </div>
                <div className="stat">
                  <div className="stat-label">Move</div>
                  <div className="stat-value">Open</div>
                </div>
              </div>

              <div className="traits">
                <span className="trait">Kind</span>
                <span className="trait">Stable</span>
                <span className="trait">Respectful</span>
                <span className="trait">Loyal</span>
                <span className="trait">Family-minded</span>
              </div>

              <div className="profile-note">Looking for a real introduction, not dating-app noise.</div>
            </div>
          </aside>
        </div>
      </section>

      <main>
        <section className="section">
          <div className="section-head">
            <h2 className="section-title">Referral requirements</h2>
          </div>

          <div className="criteria-grid">
            <div className="criteria-card">
              <div className="criteria-icon">20-26</div>
              <h3 className="criteria-title">Age range</h3>
              <p className="criteria-copy">Someone between 20 and 26 years old.</p>
            </div>

            <div className="criteria-card">
              <div className="criteria-icon">167cm+</div>
              <h3 className="criteria-title">Height</h3>
              <p className="criteria-copy">At least 167cm tall.</p>
            </div>

            <div className="criteria-card">
              <div className="criteria-icon">Slim</div>
              <h3 className="criteria-title">Build</h3>
              <p className="criteria-copy">Thin or slim build.</p>
            </div>

            <div className="criteria-card">
              <div className="criteria-icon">Caucasian</div>
              <h3 className="criteria-title">Other</h3>
              <p className="criteria-copy">Caucasian and open to a serious relationship.</p>
            </div>
          </div>
        </section>

        <section className="section tight" style={{ textAlign: 'center' }}>
          <h2 className="section-title">How it works</h2>
          <br></br>
          <div className="info-card">
            <ul className="info-list">
              <li className="info-item">
                <span className="check">1</span>
                <span>Leave your phone number using the form above.</span>
              </li>
              <li className="info-item">
                <span className="check">2</span>
                <span>I'll reach out privately to ask who you have in mind.</span>
              </li>
              <li className="info-item">
                <span className="check">3</span>
                <span>If the introduction is genuine and we go on a successful first date, I'll sign a legally binding contract with you covering the referral reward.</span>
              </li>
              <li className="info-item">
                <span className="check">4</span>
                <span>If we begin dating successfully, the reward timeline starts.</span>
              </li>
              <li className="info-item">
                <span className="check">5</span>
                <span>You receive $3,000 USD after three months of successful dating, and $10,000 USD if we marry.</span>
              </li>
            </ul>
          </div>
        </section>

        <section className="section tight">
          <div className="cta">
            <div className="cta-inner">
              <h2 className="section-title">Think of someone?</h2>
              <p className="section-sub">
                Leave your number and I will personally follow up to discuss the potential introduction.
              </p>
              <button type="button" className="cta-button" onClick={scrollToLeadForm}>
                Leave your number
              </button>

            </div>
          </div>
        </section>
      </main>

    </div>
  )
}

export default App